"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
var react_1 = __importStar(require("react"));
var main_1 = require("./screens/main");
var socket_1 = require("./socket");
var react_redux_1 = require("react-redux");
var console_1 = require("./reducers/slices/console");
var App = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        function onConnect() {
            dispatch((0, console_1.setSocketStatus)(true));
        }
        function onDisconnect() {
            dispatch((0, console_1.setSocketStatus)(false));
        }
        socket_1.socket.on("connect", onConnect);
        socket_1.socket.on("disconnect", onDisconnect);
        return function () {
            socket_1.socket.off("connect", onConnect);
            socket_1.socket.off("disconnect", onDisconnect);
        };
    }, []);
    return react_1.default.createElement(main_1.MainScreen, null);
    // return <MainTestScreen />;
};
exports.App = App;
